export default function ServicesSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      icon: 'ri-advertisement-line',
      color: 'bg-blue-500',
      title: 'Gestão de Tráfego Pago',
      description: 'Criação, otimização e gestão de campanhas de mídia paga (Google Ads, Meta Ads, LinkedIn Ads, etc.) para gerar leads qualificados.'
    },
    {
      icon: 'ri-pages-line',
      color: 'bg-purple-500',
      title: 'Criação de Landing Pages e Formulários de Conversão',
      description: 'Desenvolvimento de páginas de alta conversão e formulários otimizados para a captura de dados de potenciais clientes.'
    },
    {
      icon: 'ri-article-line',
      color: 'bg-green-500',
      title: 'Produção de Conteúdo Estratégico',
      description: 'Criação de posts, artigos e materiais ricos (e-books, whitepapers) que atraem, educam e engajam o público-alvo.'
    },
    {
      icon: 'ri-robot-2-line',
      color: 'bg-orange-500',
      title: 'Automação de Marketing',
      description: 'Configuração de ferramentas (RD Station, HubSpot, ActiveCampaign) para nutrir leads e qualificá-los para vendas.'
    },
    {
      icon: 'ri-database-2-line',
      color: 'bg-pink-500',
      title: 'Gestão e Análise de CRM',
      description: 'Organização e otimização de leads em sistemas (Pipedrive, HubSpot) para um repasse eficiente ao time de vendas.'
    },
    {
      icon: 'ri-search-line',
      color: 'bg-indigo-500',
      title: 'SEO (Search Engine Optimization)',
      description: 'Estratégias para aumentar a visibilidade orgânica nos mecanismos de busca e atrair tráfego qualificado.'
    },
    {
      icon: 'ri-share-line',
      color: 'bg-red-500',
      title: 'Social Ads e Remarketing',
      description: 'Segmentação de público-alvo em redes sociais para impactar pessoas em diferentes etapas da jornada de compra.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      color: 'bg-yellow-500',
      title: 'Monitoramento de Resultados e Relatórios',
      description: 'Análise de métricas (custo por lead, taxa de conversão, ROI) e ajustes contínuos de estratégias para otimização.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-red-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nossos <span className="text-red-400">Serviços</span>
            <br />
            <span className="text-lg text-red-300 font-normal italic">"Estratégias com a precisão de uma katana"</span>
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Na IchiBan Marketing Digital, criamos estratégias para atrair potenciais clientes por meio de marketing digital, usando canais online como anúncios pagos, redes sociais, e-mail marketing, blogs e outras ferramentas digitais. Geramos tráfego qualificado para o site, landing pages ou WhatsApp — ou seja, pessoas que tenham perfil de compra e interesse no produto ou serviço. Convertemos esse tráfego em leads, qualificamos os leads para identificar quem realmente tem potencial de compra (lead scoring) e entregamos os leads qualificados ao time de vendas do cliente.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-black/70 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group border border-red-500/30"
            >
              <div className={`${service.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-white mb-6 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-red-600 to-red-500 rounded-3xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-6">Pronto para Acelerar seu Crescimento?</h3>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Nossa equipe de especialistas está pronta para criar uma estratégia personalizada que vai transformar seus resultados digitais.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-white text-red-600 px-8 py-4 rounded-full font-semibold text-lg hover:shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Solicitar Proposta
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-red-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Agendar Consultoria
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
